import { Link } from "react-router-dom/cjs/react-router-dom.min";
import CompScroll from "./CompScroll";
import recruit from "../assets/dummy/DataRecruit.json";
import { useMediaQuery } from "react-responsive";

function MainRecruit() {
  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });


  return (
    <>
      <div className="recruit">
        <div className="section-txt-wrap">
          <h2 className="section-title">인재 채용</h2>
          <div className="section-content">
            <p>
              헬리오센은 배려와 공감 속에서 창의와 자율을 통해 능력을 개발하고
              발휘하면서 동료와 회사가 동반 성장하는 문화를 가진 회사입니다.
            </p>
          </div>
          <Link className="link-fit" to="/recruit/jobposition">
            <button className="section-btn-wrap">
              <span className="section-btn-more">자세히 보기</span>
              <span className="section-btn"></span>
            </button>
          </Link>
        </div>
        <div>
          {pc ? (
            <ul className="recruit-list">
              {recruit.Recruit.slice(recruit, 4)
                .reverse()
                .map((rec) => (
                  <li className="recruit-item" key={rec.id}>
                    <div className="recruit-txt-wrap">
                      <p className="recruit-badge">채용중</p>
                      <div>
                        <Link
                          to={`/recruit/jobposition/${rec.id}`}
                          className="recruit-link"
                        >
                          {rec.title}
                          <span className="line"></span>
                        </Link>
                      </div>
                    </div>
                    <p>{rec.date}</p>
                  </li>
                ))}
            </ul>
          ) : (
            <ul className="recruit-list">
              {recruit.Recruit.slice(recruit, 4)
                .reverse()
                .map((rec) => (
                  <li className="recruit-item" key={rec.id}>
                    <p className="recruit-badge">채용중</p>
                    <div className="recruit-txt-wrap">
                      <div>
                        <Link
                          to={`/recruit/jobposition/${rec.id}`}
                          className="recruit-link"
                        >
                          {rec.title}
                        </Link>
                      </div>
                      <p className="recruit-date">{rec.date}</p>
                    </div>
                  </li>
                ))}
            </ul>
          )}
        </div>
      </div>
      <CompScroll value={4} />
    </>
  );
}

export default MainRecruit;
